import DataTable from "react-data-table-component";
import React, { useEffect } from "react";
import { Col, Row } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  setReportLimit,
  setReportPage,
} from "../../../../redux/actions/reports/reportsAction";
import { history } from "../../../../app/AppRouter";
import { conditionalRowStyles,addExtraColumnPerGymSettings } from "./utils";

export const ReportsTable = ({ columns,clickedRow,withExtraCols }) => {
  const { reports, reportsCount } = useSelector((state) => state.report);
  const [reportColumns, setReportColumns] = React.useState(columns);
  const {gym} = useSelector((state) => state.gym);
  const dispatch = useDispatch();
  useEffect(()=>{
    if(withExtraCols){
      const settings =gym?.settings
      const {extraFieldsForTable}=addExtraColumnPerGymSettings({settings})
      setReportColumns([...columns,...extraFieldsForTable])
    }
    else setReportColumns(columns)

  },[withExtraCols,gym])
  return (
    <Row>
      <Col xs={12} className="mt-4">
        {reports && (
          <DataTable
            className="dark-blue-table"
            columns={reportColumns}
            data={reports}
            conditionalRowStyles={conditionalRowStyles}
            pagination
            paginationServer
            paginationTotalRows={reportsCount}
            onChangeRowsPerPage={(newLimit) =>
              dispatch(setReportLimit(newLimit))
            }
            onChangePage={(newPage) => dispatch(setReportPage(newPage))}
            onRowClicked={(row)=>{
              if(clickedRow){
                history.push(`/gym-panel/membersinfo/${row?.memberId}`);

              }
              }}
               // Add this line to handle row clicks

          />
        )}
        
      </Col>
    </Row>
  );
};
